import { useState, useEffect } from 'react';

import './AdminProtocols.css';
import ProtocolModal from './ProtocolModal';
import ProtocolEditModal from './ProtocolEditionModal';

import { getProtocols } from '../../../requests/admin/protocol';

//MUI
import {
  Box, Button, Container, Grid, Stack, Typography, Backdrop,
  Fab, useMediaQuery
} from '@mui/material'
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';

// import img from '../../../Assets/Images/Simbiotico.jpg'
// import img_1 from '../../../Assets/Images/Malteada-Nutritiva-vainilla-490g_1.jpg'

// import protocol from '../../../Assets/Resources/protocolos/reporte_preliminar_simbiotico_nin.pdf'
// import protocol_1 from '../../../Assets/Resources/protocolos/Malteada_Nutritiva_NIN_preliminar_junio-2024.pdf'

//react-beatufil-dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { GOOGLE_DRIVE_CDN } from '../../../constants/main_constants';

const CustomButton = styled(Button)(({ theme }) => ({
  color: '#fffff',
  backgroundColor: '#283A49',
  '&:hover': {
    backgroundColor: '#405668',
  },
}));

const AdminProtocols = () => {

  const matches = useMediaQuery('(max-width: 480px)');

  // referencias para subida de archivos en edición de protocol
  // const inputRef = useRef(); // referencia imagen
  // const fileInputRef = useRef(); // referencia documento

  // control de modales
  const [openDialog, setOpenDialog] = useState({
    register: false, edit: false
  });
  const { register, edit } = openDialog;

  // lista de protocolos
  const [protocols, setProtocols] = useState([]);
  // orden inicial de protocolos (conocer si hubo cambios en lista)
  const [originalOrderString, setOriginalOrderString] = useState("");
  // backdrop
  const [open, setOpen] = useState(false);

  // información de protocolo para edición
  const [protocol, setProtocol] = useState({
    protocolId: 0,
    name: '',
    publicationDate: new Date(),
    folderId: '',
    imageId: '',
    documentId: '',
    documentName: '',
    // valores locales
    image: '',
    file: '',
    imageFile: '',
    documentFile: '',
  });

  // usuario cambio el orden en la lista Draggable
  const hasOrderChanged = protocols.map(p => p.protocolId).join(',') !== originalOrderString; 

  useEffect(() => {
    getProtocols(setProtocols, setOriginalOrderString);
  }, []);

  useEffect(() => {
    // console.log(protocols)
    // console.log(protocols.map(p => p.protocolId).join(','))
  }, [protocols]);

  // useEffect(() => {
  //   console.log(originalOrderString)
  // }, [originalOrderString]);

  const handleOpen = () => setOpenDialog(e => ({ ...e, register: true }));

  //drag
  const handleDrag = (result) => {
    if (!result.destination) return;

    const arr = [...protocols];

    //Changing the position of Array element
    let removedItem = arr.splice(result.source.index, 1)[0];
    arr.splice(result.destination.index, 0, removedItem);

    //Updating the list
    setProtocols(arr);
  };

  const editProtocol = protocolId => () => {
    const ProtocolFound = protocols.find(e => e.protocolId === protocolId);
    if (!ProtocolFound)
      return;
    
    const { name, publicationDate, folderId, imageId, documentId, documentName } = ProtocolFound;
    setProtocol({
      protocolId, name, publicationDate: new Date(publicationDate),
      folderId, imageId, documentId, documentName,
      image: '', file: '', imageFile: '', documentFile: '',
    });
    // limpiar referencias
    // inputRef.current.value = '';
    // fileInputRef.current.value = '';

    setOpenDialog(e => ({ ...e, edit: true }));
  };

  return (
    <>
      <Container maxWidth='xl' sx={{ mb: 5 }}>
        <Typography variant='h5' sx={{ fontWeight: '600', fontSize: '28px' }} paragraph>Lista de protocolos publicados</Typography>
        <Button variant='contained' sx={{ textTransform: 'none', mb: 5 }} endIcon={<AddIcon />} onClick={handleOpen}>Añadir nuevo protocolo</Button>

        <DragDropContext onDragEnd={handleDrag}>
          <Droppable droppableId="protocols">
            {(provided) => (
              <Grid container spacing={3} {...provided.droppableProps} ref={provided.innerRef}>
                {
                  protocols.map(({ protocolId, name, displayDate, imageId, documentId }, index) => (
                    <Draggable
                      key={protocolId}
                      draggableId={protocolId.toString()}
                      index={index}
                    >
                      {(provided) => (
                        <Grid item xl={6} lg={6} md={12} sm={12} xs={12}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Box className='protocol_box' sx={{ p: 2 }}>
                            <Box className='protocol_content'>
                              <Box className='protocol_ini'>
                                <Box sx={{ my: 'auto' }}>
                                  <img src={`${GOOGLE_DRIVE_CDN}${imageId}`} alt='protocol' className='img_protocol' />
                                </Box>
                                <Box sx={{ my: 'auto' }}>
                                  <Typography variant='body1'>{name}</Typography>
                                  <a href={`${GOOGLE_DRIVE_CDN}${documentId}`} target='_blank' rel="noopener noreferrer" style={{ textDecoration: 'none' }}>Visualizar documento</a>
                                </Box>
                              </Box>
                              <Box sx={{ my: 'auto' }}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>Fecha de publicación:</Typography>
                                <Typography variant='body1'> {displayDate} </Typography>
                              </Box>
                            </Box>
                            <Stack direction='row' spacing={2} sx={{ mt: 2, justifyContent: matches ? 'center' : 'flex-start' }}>
                              <CustomButton
                                size='small' variant='contained'
                                startIcon={<EditIcon />} onClick={editProtocol(protocolId)}>
                                Editar
                              </CustomButton>
                              <CustomButton size='small' variant='contained' startIcon={<DeleteIcon />}>Eliminar</CustomButton>
                            </Stack>
                          </Box>
                        </Grid>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </Grid>
            )}
          </Droppable>
        </DragDropContext>
      </Container>

      <ProtocolModal
        openDialog={register}
        setOpenDialog={setOpenDialog}
        // formValues={formValues}
        // setFormValues={setFormValues}
        setOpen={setOpen}
        setProtocols={setProtocols}
      />

      <ProtocolEditModal
        openDialog={edit}
        setOpenDialog={setOpenDialog}
        setOpen={setOpen}
        protocol={protocol}
        setProtocol={setProtocol}
        setProtocols={setProtocols}
        // inputRef={inputRef}
        // fileInputRef={fileInputRef}
      />
      
      {
        hasOrderChanged &&
          <Fab color='primary' sx={{ position: 'fixed', bottom: 15, right: 30 }}>
            <SaveIcon />
          </Fab>
      }

      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default AdminProtocols;